import React, { useState } from 'react';
import { Button, Stack, Text, Anchor, Group, Container, useMantineTheme } from '@mantine/core';
import { IconBrandSpotify, IconMessages, IconPlus } from '@tabler/icons-react';
import { FAQPopup } from '../faq';
import { blobAnimation } from '../../styles/animations';
import { useRouter } from 'next/router';
import { REQUEST_FELLOWSHIP_FORM_URL } from '../../config';
import { useWeb3Context } from '../../providers/Web3Provider/useWeb3Context';
import useGameMasterBackend from '../../hooks/useGameMasterBackend';
import { FellowshipGardenButton } from './FellowshipGardenButton';

export const EnterArenas = () => {
  const [faqOpened, setFaqOpened] = useState(false);
  const router = useRouter();
  const theme = useMantineTheme();
  const web3Context = useWeb3Context();
  const { useFellowshipByArena } = useGameMasterBackend();

  // Get Fellowship Garden data
  const { data: fellowshipGarden } = useFellowshipByArena('invisible-garden');

  return (
    <Container size="sm" py="4rem">
      <Stack align="center" gap="3rem">
        <Group gap="3.5rem" className={blobAnimation}>
          <Text ta="center" component="h2" fz={{ base: '2rem', sm: '3rem' }} lh={{ base: '2rem', sm: '3rem' }}>
            Enter the Arena
          </Text>
          <span></span>
        </Group>

        <Text ta="center" size="xl" c="dimmed" mt="-1rem" fz={{ base: '1rem', sm: '1.5rem' }}>
          Check out our{' '}
          <Anchor component="button" onClick={() => setFaqOpened(true)}>
            FAQ
          </Anchor>{' '}
          to get started — or head straight to the Arena to create your first Thread!
        </Text>

        <Group mt="2rem" gap="xl" w={{ base: '100%', xs: 'auto' }} justify="center">
          <Button
            size="lg"
            bg="#5f3dc4"
            onClick={() => router.push('/brain-breeze')}
            leftSection={<IconMessages size={27} />}
            fullWidth={false}
            w={{ base: '100%', xs: 'auto' }}
          >
            Discussion Arena
          </Button>
          <Button
            size="lg"
            variant="filled"
            color="#1DB954"
            leftSection={<IconBrandSpotify size={27} />}
            onClick={() => router.push('/music')}
            fullWidth={false}
            w={{ base: '100%', xs: 'auto' }}
          >
            Music Game Arena
          </Button>
          {web3Context.account && web3Context.currentChain && fellowshipGarden && (
            <FellowshipGardenButton fellowship={fellowshipGarden} />
          )}
        </Group>
        <Group mt="2rem" gap="xl" w={{ base: '100%', xs: 'auto' }}>
          <Button
            size="md"
            variant="outline"
            color="orange"
            style={{
              borderColor: theme.colors.orange[5],
            }}
            leftSection={<IconPlus size={27} />}
            onClick={() => window.open(REQUEST_FELLOWSHIP_FORM_URL, '_blank')}
            fullWidth={false}
            w={{ base: '100%', xs: 'auto' }}
          >
            Request new Arena
          </Button>
        </Group>
      </Stack>

      <FAQPopup opened={faqOpened} onClose={() => setFaqOpened(false)} />
    </Container>
  );
};
